import { useEffect, useMemo, useState } from 'react';
import { DEFAULT_LIST_LIMIT, paginateItems } from '../utils/listPagination';

/**
 * Client-side paging for in-memory list/table views.
 * Keeps existing layout; ListPager renders only when there is more than one page.
 */
export function useClientPager(items, { limit = DEFAULT_LIST_LIMIT, resetKey } = {}) {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const paged = useMemo(
    () => paginateItems(Array.isArray(items) ? items : [], page, limit),
    [items, page, limit]
  );

  useEffect(() => {
    if (page !== paged.pagination.page) setPage(paged.pagination.page);
  }, [page, paged.pagination.page]);

  return {
    page: paged.pagination.page,
    setPage,
    pageItems: paged.items,
    pagination: paged.pagination,
  };
}
